import React from 'react'
import { format, fromUnixTime } from 'date-fns'
import { BusinessPhase, Sprint } from '@marketing-milk/interfaces'
import { accentSoft, SurfacePalette, type } from '../tokens'

interface Props {
  palette: SurfacePalette
  businessName: string | undefined
  phase: BusinessPhase | undefined
  sprint: Sprint
}

const PHASE_LABEL: Record<BusinessPhase, string> = {
  [BusinessPhase.CRAWL]: 'Crawl',
  [BusinessPhase.WALK]: 'Walk',
  [BusinessPhase.RUN]: 'Run',
  [BusinessPhase.FLY]: 'Fly',
}

export const PacketHeader = ({ palette, businessName, phase, sprint }: Props) => {
  const start = fromUnixTime(sprint.startTime)
  const end = fromUnixTime(sprint.endTime)
  const dateRange = `${format(start, 'MMM d, yyyy')} – ${format(end, 'MMM d, yyyy')}`
  const phaseLabel = phase !== undefined ? PHASE_LABEL[phase] : undefined

  return (
    <header
      className="px-6 py-4"
      style={{
        background: palette.surface,
        borderBottom: `1px solid ${palette.hairline}`,
        fontFamily: type.family.sans,
      }}
    >
      <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
        <h1
          style={{
            fontFamily: type.family.sans,
            fontSize: type.size.h2,
            fontWeight: type.weight.semibold,
            color: palette.text,
            lineHeight: 1.1,
            margin: 0,
          }}
        >
          {businessName ?? '—'}
        </h1>
        <span style={{ fontSize: type.size.body, color: palette.textMuted }}>{sprint.name}</span>
        <span style={{ fontSize: type.size.body, color: palette.textFaint }}>{dateRange}</span>
        {phaseLabel && (
          <span
            className="ml-auto inline-flex items-center"
            style={{
              fontFamily: type.family.mono,
              fontSize: type.size.eyebrow,
              fontWeight: type.weight.medium,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: palette.accent,
              padding: '2px 10px',
              borderRadius: 999,
              border: `1px solid ${palette.accent}`,
              background: accentSoft,
            }}
          >
            {phaseLabel}
          </span>
        )}
      </div>
    </header>
  )
}
